<template>
  <header class="border-bdr-subtle box-content flex h-10 items-center justify-between border-b">
    <div class="flex grow items-center gap-2 px-3 py-1.5">
      <slot>
        <p class="text-body-default-m">
          {{ title }}
        </p>
      </slot>
    </div>
    <Button
      v-if="hasClose"
      icon-only
      :variant="ButtonVariant.Tertiary"
      class="mx-2 my-1.5"
      @click="() => emits('close')"
      ><Icon src="X"
    /></Button>
  </header>
</template>

<script lang="ts" setup>
  const { hasClose = true, title } = defineProps<{
    hasClose?: boolean;
    title: string;
  }>();
  const emits = defineEmits<{
    (e: "close" | "back"): void;
  }>();
</script>
